import { RootState } from '@vision/ui/store';

export const selectContentCategoriesSelector = (state: RootState) => state.ContentCategoriesState.contentCategories;

export const selectContentCategoriesTreeCheckedStateSelector = (state: RootState) =>
  state.ContentCategoriesState.contentCategoriesTreeCheckedState;
